/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * jeeves/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * Where in a run a content match was found.
More sources may be added; treat a value you do not recognize as an unknown
place in the run.

 - CONTENT_MATCH_SOURCE_UNSPECIFIED: Unspecified source. Not returned by the server.
 - CONTENT_MATCH_SOURCE_INPUT: A file in the run's inputs (user_inputs).
 - CONTENT_MATCH_SOURCE_OUTPUT: A file in the run's outputs.
 - CONTENT_MATCH_SOURCE_TRIGGER: A file in the payload the run was started with, such as an attachment of the
email that triggered it, when the file is not also one of the run's inputs.
 - CONTENT_MATCH_SOURCE_STEP_FILE: A file one of the run's steps used, found through the Run log.
 - CONTENT_MATCH_SOURCE_STEP_OUTPUT: Text one of the run's steps produced, found through the Run log, such as the
fields a document-processing book extracted. display_name names the file the
step read, if it read one.
 */
export type V1ContentMatchSource =
  (typeof V1ContentMatchSource)[keyof typeof V1ContentMatchSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1ContentMatchSource = {
  CONTENT_MATCH_SOURCE_UNSPECIFIED: 'CONTENT_MATCH_SOURCE_UNSPECIFIED',
  CONTENT_MATCH_SOURCE_INPUT: 'CONTENT_MATCH_SOURCE_INPUT',
  CONTENT_MATCH_SOURCE_OUTPUT: 'CONTENT_MATCH_SOURCE_OUTPUT',
  CONTENT_MATCH_SOURCE_TRIGGER: 'CONTENT_MATCH_SOURCE_TRIGGER',
  CONTENT_MATCH_SOURCE_STEP_FILE: 'CONTENT_MATCH_SOURCE_STEP_FILE',
  CONTENT_MATCH_SOURCE_STEP_OUTPUT: 'CONTENT_MATCH_SOURCE_STEP_OUTPUT',
} as const;
